import { Card as ANTDCard, Space, Tag, Typography } from 'antd'
import { PlatformUsage } from '../../models/Platform'

const { Text } = Typography

interface Props {
  registeredPlatform?: PlatformUsage
}
export const UserPlatformCard = ({ registeredPlatform }: Props) => {
  const usage = registeredPlatform

  if (!usage) {
    return <></>
  }
  return (
    <ANTDCard>
      <Space className="w-full space-between">
        <Text>
          {usage.platform.icon} {usage.platform.name}
        </Text>
        <Space>
          {usage.osVersion && <Tag color="purple">{usage.osVersion}</Tag>}
          {usage.platformVersion && (
            <Tag color="green">{usage.platformVersion}</Tag>
          )}
        </Space>
      </Space>
    </ANTDCard>
  )
}

export type UserPlatformCardType = { PlatformCard: typeof UserPlatformCard }
